/*=========================================================================================
  File Name: moduleSigepActions.js
  Description: Sigep Module Actions
==========================================================================================*/

import axios from "@/axios.js"

export default {

  validateCreds({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_PREFIX + "/sigepCreds")
        .then((response) => {
          if(response.data[0]) {
            commit('SET_INFO', response.data[0])
            resolve(response.data[0])
          } else {
            const defaultData = {
              id: 0,
              idShop: 0,
              configDeclararNf: false,
              configDeclararValor: 1,
              configLogo: "",
              usuario: "",
              senha: "",
              cnpj: "",
              diretoria: "",
              codigoAdministrativo: "",
              cartaoPostagem: "",
              contrato: "",
              equivalents: [],
              valid: 0,
              validError: "",
              services: [],
              remetente: {
                firstName: "",
                lastName: "",
                address: "",
                number: "",
                complement: "",
                zipCode: "",
                region: "",
                city: "",
                state: "",
                country: "BR",
                valid: false
              },
              usuarioApi: "",
              senhaApi: "",
              cartaoPostagemApi: ""
            };

            commit('SET_INFO', defaultData)
            resolve(defaultData)
          }
        })
        .catch(() => {
          // se 401 logout
          // If JWT login
          if (localStorage.getItem("accessToken")) {
            localStorage.removeItem("accessToken")
            this.$router.push('/pages/login').catch(() => {})
          }
          // reject(error)
        })
    })
  },


  updateCreds({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.put(process.env.VUE_APP_PREFIX + "/sigepCreds/" + data.id, data)
        .then((response) => {
          // console.log(response)
          commit('UPDATE_INFO', response.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },


}
